import { render } from "./App.vue?vue&type=template&id=10f7c95b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10f7c95b&lang=css"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__